import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import agent from '../../agent';
import useTranslation from '../../customHooks/translations';
import { DEFAULT_THEME_COLOR } from '../../constants/theme';

/** Settings → "Blocked users": everyone I blocked, with "Unblock". */
const BlockedUsersList = () => {
  const strings = useTranslation().userBlock;
  const [users, setUsers] = useState(null);
  const [error, setError] = useState(false);

  const load = () => {
    agent.Profile.blocked()
      .then((res) => setUsers(res?.users || []))
      .catch(() => setError(true));
  };

  useEffect(load, []);

  const unblock = async (username) => {
    try {
      await agent.Profile.unblock(username);
      setUsers((current) => current.filter((u) => u.username !== username));
    } catch (e) {
      setError(true);
    }
  };

  if (error) {
    return <Typography sx={{ color: '#f87171', fontSize: '0.85rem' }}>{strings.error}</Typography>;
  }
  if (!users) return null;
  if (!users.length) {
    return <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.85rem' }}>{strings.empty}</Typography>;
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      {users.map((user) => (
        <Box key={user.username} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar src={user.image || undefined} sx={{ width: 32, height: 32 }}>
            {user.username.slice(0, 1).toUpperCase()}
          </Avatar>
          <Typography sx={{ color: 'white', flex: 1, fontSize: '0.9rem' }}>{user.username}</Typography>
          <Button
            size="small"
            variant="outlined"
            sx={{ color: DEFAULT_THEME_COLOR, borderColor: DEFAULT_THEME_COLOR, textTransform: 'none', zIndex: 0 }}
            onClick={() => unblock(user.username)}
            data-testid={`unblock-${user.username}`}
          >
            {strings.unblock}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default BlockedUsersList;
